import { RefObject, useEffect } from 'react';

type Params = {
  dropdownRef: RefObject<HTMLDivElement>;
  contentRef: RefObject<HTMLDivElement>;
  triggerRef: RefObject<HTMLDivElement>;
  isUpwards: boolean;
  isBackwards: boolean;
  renderAsPortal: boolean;
};

const useResizeReposition = ({
  dropdownRef,
  triggerRef,
  contentRef,
  isUpwards,
  isBackwards,
  renderAsPortal,
}: Params) => {
  useEffect(() => {
    const setCoords = () => {
      if (!dropdownRef.current) return;

      const { top: dropdownTopOffset, left: dropdownLeftOffset } =
        dropdownRef.current.getBoundingClientRect();

      let topOffset = dropdownTopOffset + window.scrollY;
      let leftOffset = dropdownLeftOffset + window.scrollX;

      const { height: triggerHeight, width: triggerWidth } =
        triggerRef.current.getBoundingClientRect();

      if (!isUpwards) {
        topOffset = topOffset + triggerHeight;
      }

      if (isBackwards) {
        leftOffset = leftOffset + triggerWidth;
      }

      contentRef.current.style.top = `${topOffset}px`;
      contentRef.current.style.left = `${leftOffset}px`;
    };

    if (renderAsPortal) {
      window.addEventListener('resize', setCoords);

      const cleanUp = () => {
        window.removeEventListener('resize', setCoords);
      };

      return cleanUp;
    }
  }, [
    dropdownRef,
    contentRef,
    triggerRef,
    isBackwards,
    isUpwards,
    renderAsPortal,
  ]);
};

export default useResizeReposition;
